var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0617 9.397L7.22835 13.5522C6.69798 14.1271 7.15055 15 7.97903 15L16.021 15C16.8494 15 17.302 14.1272 16.7716 13.5522L12.9383 9.397C12.45 8.86767 11.55 8.86766 11.0617 9.397Z",
    fill: "#7266BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight2);
export default __webpack_public_path__ + "static/media/chevronRight_2.1872f902c5f29aa7607377dfd8fa699f.svg";
export { ForwardRef as ReactComponent };